import './calendar-day-cell.scss';
import type { RefObject } from 'react';
import { MAX_VISIBLE_DAY_MEETINGS } from '../../constants/calendar';
import type { CalendarDayItem } from '../calendar/calendar.types';

type CalendarDayCellProps = {
  day: Date;
  isInCurrentMonth: boolean;
  isToday: boolean;
  dayItems: CalendarDayItem[];
  isOverflowOpen: boolean;
  overflowRef: RefObject<HTMLDivElement | null>;
  onToggleOverflow: () => void;
  onSelectItem: (dayItem: CalendarDayItem) => void;
};

const CalendarDayCell = ({
  day,
  isInCurrentMonth,
  isToday,
  dayItems,
  isOverflowOpen,
  overflowRef,
  onToggleOverflow,
  onSelectItem,
}: CalendarDayCellProps) => {
  const visibleDayItems = dayItems.slice(0, MAX_VISIBLE_DAY_MEETINGS);
  const hasOverflowItems = dayItems.length > MAX_VISIBLE_DAY_MEETINGS;

  return (
    <div
      className={`meeting-calendar__day ${isInCurrentMonth ? '' : 'is-muted'} ${isToday ? 'is-today' : ''} ${
        dayItems.length ? 'has-meetings' : ''
      }`}
    >
      <div className="meeting-calendar__day-button">
        <span className="meeting-calendar__day-number">{day.getDate()}</span>
        {dayItems.length > 0 && <span className="meeting-calendar__count">{dayItems.length}</span>}
      </div>

      {dayItems.length > 0 && !hasOverflowItems && (
        <div className="meeting-calendar__events meeting-calendar__events--stacked">
          {visibleDayItems.map((dayItem) => (
            <button
              key={`${dayItem.kind}-${dayItem.item.id}`}
              type="button"
              className={`meeting-calendar__event-line meeting-calendar__event-line--${dayItem.kind}`}
              onClick={() => onSelectItem(dayItem)}
            >
              <span className="meeting-calendar__event-line-title">{dayItem.item.title}</span>
            </button>
          ))}
        </div>
      )}

      {hasOverflowItems && (
        <div className="meeting-calendar__overflow" ref={isOverflowOpen ? overflowRef : null}>
          <button
            type="button"
            className="meeting-calendar__multiple-button"
            onClick={onToggleOverflow}
            aria-expanded={isOverflowOpen}
          >
            <span>{dayItems.length} Items</span>
            <span className="meeting-calendar__multiple-arrow" aria-hidden="true">
              ▾
            </span>
          </button>

          {isOverflowOpen && (
            <div className="meeting-calendar__overflow-menu">
              {dayItems.map((dayItem) => (
                <button
                  key={`${dayItem.kind}-${dayItem.item.id}`}
                  type="button"
                  className={`meeting-calendar__overflow-item meeting-calendar__overflow-item--${dayItem.kind}`}
                  onClick={() => onSelectItem(dayItem)}
                >
                  <span className="meeting-calendar__overflow-item-title">{dayItem.item.title}</span>
                  {dayItem.item.time && (
                    <span className="meeting-calendar__overflow-item-time">{dayItem.item.time}</span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CalendarDayCell;
